var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.875V15.25C10.5 16.0784 11.1716 16.75 12 16.75V16.75C12.8284 16.75 13.5 16.0784 13.5 15.25V7C13.5 5.34315 12.1569 4 10.5 4V4C8.84315 4 7.5 5.34315 7.5 7L7.5 15.5C7.5 17.9853 9.51472 20 12 20V20C14.4853 20 16.5 17.9853 16.5 15.5V12.75",
    stroke: "#262728",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/Attach File.85a4085d26594b24455d8a25c3099f07.svg";
export { ForwardRef as ReactComponent };